<nav class="navbar navbar-light bg-light navbar-expand-lg">
  <form class="form-inline flex-fill d-flex w-100 flex-column flex-lg-row">
    <button [disabled]="bloquear" class="navbar-toggler" type="button" data-toggle="collapse"
            data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false"
            aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>
    <ul class="navbar-nav me-auto">
      <!--buscador -->
      <li class="nav-item mr-2">
        <div class="nav-item">
          <input [disabled]="bloquear" id="busquedaFormControl" type="text" class="form-control"
                 [formControl]="busquedaFormControl" placeholder="Buscador" />
        </div>
      </li>
      <li class="nav-item">
        <div ngbDropdown autoClose="outside">
          <button [disabled]="bloquear" type="button" class="btn btn-outline-primary my-2 my-lg-0 mx-lg-2"
                  id="dropdownEstado" ngbDropdownToggle>Estado</button>
          <div ngbDropdownMenu aria-labelledby="dropdownAreas">
            <div class="px-4 py-3">
              <div *ngFor="let estado of EstadosFiltros; let i = index">
                <div class="form-check">
                  <input type="checkbox" class="form-check-input"
                         id="{{ 'dropdownCheck' + estado }}"
                         [name]="'estado' + i"
                         [ngModel]="selecciones.get(estado)"
                         (ngModelChange)="selecciones.set(estado, $event)">
                  <label class="form-check-label text-nowrap"
                         for="{{ 'dropdownCheck' + estado }}">
                    {{ obtenerEtiqueta(estado) }}
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </li>

      <li class="nav-item">
        <div ngbDropdown autoClose="outside">
          <button [disabled]="bloquear" type="button" class="btn btn-outline-primary my-2 my-lg-0 mx-lg-2"
                  id="dropdownComerciales" ngbDropdownToggle>Comerciales</button>
          <div ngbDropdownMenu aria-labelledby="dropdownAreas">
            <div class="px-4 py-3">
              <div *ngFor="let comercial of comercialesFiltros; let i = index;">
                <div class="form-check">
                  <input type="checkbox" name="comerciales+{{i}}" class="form-check-input"
                         id="{{ 'dropdownCheck' + comercial.id}}" [(ngModel)]="comercial.seleccionado">
                  <label class="form-check-label text-nowrap" for="{{ 'dropdownCheck' + comercial.id}}">
                    {{ comercial.nombresCompletos }}
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </li>

      <li class="nav-item">
        <div ngbDropdown autoClose="outside">
          <button [disabled]="bloquear" type="button" class="btn btn-outline-primary my-2 my-lg-0 mx-lg-2"
                  id="dropdownEjecutivo" ngbDropdownToggle>Ejecutivo de cuenta</button>
          <div ngbDropdownMenu aria-labelledby="dropdownAreas">
            <div class="px-4 py-3">
              <div *ngFor="let ejecutivo of ejecutivosFiltros; let i = index;">
                <div class="form-check">
                  <input type="checkbox" name="ejecutivos+{{i}}" class="form-check-input"
                        id="{{ 'dropdownCheck' + ejecutivo.id}}" [(ngModel)]="ejecutivo.seleccionado">
                  <label class="form-check-label text-nowrap" for="{{ 'dropdownCheck' + ejecutivo.id}}">
                    {{ ejecutivo.nombresCompletos }}
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </li>
       <li>
           <button [disabled]="bloquear || bloquearPendiente || bloquearActualizar" (click)="getSaldosConFiltros()"
                   class="btn btn-primary px-4">
               <i class="fa fa-search me-2"></i> Buscar
           </button>
       </li>
    </ul>
    <!-- Segunda lista: botones a la derecha -->
    <ul class="navbar-nav ms-lg-auto ms-0 mt-2 mt-lg-0 w-lg-auto">
      @if (solapaReporte == TipoReporte.reporteSaldo) {
        <li class="nav-item">
          <button [disabled]="bloquear" class="btn btn-outline-success" (click)="exportarExcel()">
            <span *ngIf="!descargandoClientes">Descargar</span>
            <div *ngIf="descargandoClientes" class="d-flex align-items-center">
              <div class="spinner-border text-dark spinner-border-sm" role="status"></div>
            </div>
          </button>
        </li>
      } @else if (solapaReporte == TipoReporte.reporteAprobador) {
        <li class="nav-item me-3 mb-1">
          <button [disabled]="bloquear || !checkSeleccionados()" class="btn btn-success" (click)="botonAprobador(enumAccionSolicitud.Aprobar)">
            <span *ngIf="accionEnProceso !== enumAccionSolicitud.Aprobar">Aprobar cambios</span>
            <div *ngIf="accionEnProceso === enumAccionSolicitud.Aprobar" class="d-flex align-items-center">
              <div class="spinner-border text-dark spinner-border-sm" role="status"></div>
              <span class="mx-1">Aprobando...</span>
            </div>
          </button>
        </li>
        <li class="nav-item">
          <button [disabled]="bloquear || !checkSeleccionados()" class="btn btn-danger" (click)="botonAprobador(enumAccionSolicitud.Rechazar)">
            <span *ngIf="accionEnProceso !== enumAccionSolicitud.Rechazar">Rechazar cambios</span>
            <div *ngIf="accionEnProceso === enumAccionSolicitud.Rechazar" class="d-flex align-items-center">
              <div class="spinner-border text-dark spinner-border-sm" role="status"></div>
              <span class="mx-1">Rechazando...</span>
            </div>
          </button>
        </li>
      }
    </ul>
  </form>
</nav>

<div class="col container-fluid">
  <form class="mb-3">
    <div class="col col-md-12">
      <div class="spinner-container" *ngIf="this.ocultarTabla">
        <ngx-spinner name="spinnerLista" bdOpacity=0.3bd
                    Color="rgba(193,193,193,0)" size="medium" color="#185db5" type="ball-grid-beat" [fullScreen]="false">
          <p style="color: white"> C a r g a n d o . . . </p>
        </ngx-spinner>
      </div>
      <div *ngIf="this.saldoClientes != null"
          id="scroll-infinito"
          class="tabla-reporteSaldo"
          infiniteScroll
          [infiniteScrollDistance]="distance"
          [infiniteScrollThrottle]="throttle"
          [scrollWindow]="false"
          [infiniteScrollDisabled]="this.obteniendoSaldosScroll || this.stopScroll"
          (scrolled)="onScroll(scrollActivo)">
        <table class="table" >
          <ng-container *ngIf="!this.ocultarTabla">
              @for (cliente of saldosFiltrados; track cliente.clienteId; let i = $index) {
              <thead class="text-center letra">
              <!-- Fila agrupadora -->

              <tr [class.borde-negro]="solapaReporte === TipoReporte.reporteSaldo">
                <th colspan="1" class="columna-cliente"></th>
                <th colspan="3"
                    [class.columna-ancho-normal]="solapaReporte === TipoReporte.reporteSaldo"
                    [class.columna-ancho-grande]="solapaReporte !== TipoReporte.reporteSaldo"
                    style="background-color: peachpuff">Situaci&oacute;n</th>
                <th colspan="3"
                    [class.columna-ancho-normal]="solapaReporte === TipoReporte.reporteSaldo"
                    [class.columna-ancho-grande]="solapaReporte !== TipoReporte.reporteSaldo"
                    style="background-color: cornflowerblue">Excedido</th>
                <th colspan="3"
                    [class.columna-ancho-normal]="solapaReporte === TipoReporte.reporteSaldo"
                    [class.columna-ancho-grande]="solapaReporte !== TipoReporte.reporteSaldo"
                    style="background-color: #b2e1fe">Vencido</th>
                @if (solapaReporte == TipoReporte.reporteSaldo) {
                  <th colspan="5" style="background-color: #cdc; width: 480px"> Configuraci&oacute;n</th>
                } @else {
                  <th colspan="1" style="background-color: #b2e1fe; width: 14.20%"></th>
                }
              </tr>
              <!-- Fila de encabezados -->
              <tr [class.borde-negro]="solapaReporte === TipoReporte.reporteSaldo">
                <th class="cliente">Cliente</th>
                <!-- Situacion -->
                <th class="situacion">L&iacute;mite de Cr&eacute;dito</th>
                <th class="situacion">Saldo SAP</th>
                <th class="situacion">Pendiente PAD</th>
                <!-- Excedido -->
                <th class="excedido">Total Excedido</th>
                <th class="excedido">Excedido Aut</th>
                <th class="excedido">Situaci&oacute;n excedido</th>
                <!-- Vencido -->
                <th class="vencido">Saldo Vencido</th>
                <th class="vencido">Vencido Aut</th>
                <th class="vencido">Situaci&oacute;n vencido</th>
                @if (solapaReporte == TipoReporte.reporteSaldo) {
                  <!-- Configuracion -->
                  <th class="config">Estado cuenta</th>
                  <th class="config">Solicitar Cr&eacute;dito</th>
                  <th class="config">Notificaciones</th>
                  <th class="config">Configuraci&oacute;n</th>
                  <th class="config">Actualizar</th>
                } @else {
                  <th class="config">Acci&oacute;n</th>
                }

              </tr>
              </thead>

              <tbody class="text-center letra mb-3">

              <td>
                <div class="d-flex align-items-center justify-content-center gap-1 fondo"
                     [class.pb-2]="solapaReporte === TipoReporte.reporteSaldo"
                     [class.pb-0]="solapaReporte !== TipoReporte.reporteSaldo">
                  <div ngbTooltip="{{cliente.clienteRazonSocial}}" class="flex-grow-0 text-truncate">
                    {{cliente.clienteRazonSocial}}
                  </div>
                  <button class="btn btn-sm fondo" *ngIf="clickeado !== cliente.clienteCuit"
                          (click)="mostrarDatos(cliente.clienteCuit)"><i class="fa fa-eye"></i></button>
                  <button class="btn btn-sm fondo" *ngIf="clickeado === cliente.clienteCuit" (click)="mostrarDatos(' ')">
                    <i class="fa fa-eye-slash"></i>
                  </button>
                </div>
                <div class="fondo" *ngIf="clickeado === cliente.clienteCuit">
                  <small class="fondo">
                     <div><b>{{tipoDocumento[cliente.tipoDocumento]}}: </b> {{cliente.clienteCuit}}<br /></div>
                     <div><b>Comercial: </b>{{cliente.comerciales}}</div>
                     <div><b>Ejecutivo: </b>{{cliente.ejecutivoCuenta?.nombresCompletos}}</div>
                  </small>
                </div>
              </td>
              <!-- Situación -->
              <td class="text-center">
               ${{cliente.limite | number: '1.0-0'}}
              </td>

              <td class="text-center">
                ${{cliente.saldo | number: '1.0-0'}}
              </td>

              <td class="text-center">
                <div class="d-flex align-items-center justify-content-center fondo">
                  ${{cliente.saldoPAD | number: '1.0-0'}}
                  @if (cliente.saldoPAD > 0){
                    <div class="ms-1 me-2">
                      <button [disabled]="bloquear" ngbTooltip="Ver aerovales" class="btn btn-outline-secondary btn-sm"
                              (click)="verAerovales(cliente, i)">
                        <i *ngIf="!cargandoPad || seleccionado != i" class="fa small fa-search" aria-hidden="true"></i>
                        <div *ngIf="cargandoPad && seleccionado == i" class="d-flex align-items-center">
                          <div class="spinner-border text-dark spinner-border-sm" role="status"></div>
                        </div>
                      </button>
                    </div>
                  }
                </div>
              </td>
              <!-- Excedido -->
              <td class="text-center">
                ${{cliente.excedido | number: '1.0-0'}}
              </td>

              <td class="text-center">
                <div style="justify-content: center" class="d-flex align-items-center fondo">
                  @if (solapaReporte === TipoReporte.reporteSaldo && cargandoPendiente[i]?.[0] === false) {
                    ${{cliente.excedidoAutorizado | number: '1.0-0'}}
                    @if (existeSolicitudExcedido && cliente.excedidoAutorizado > 0) {
                      <button type="button" [disabled]="bloquear"
                              (click)="anularAutorizado(i, 0, getSolicitudExcedido(cliente), accionEliminar.Excedido)"
                              class="fondo" style="border-style: none;" ngbTooltip="Anular autorizado">
                        <i class="fa fa-trash"></i>
                      </button>
                    }
                  } @else if (solapaReporte === TipoReporte.reporteSaldo && cargandoPendiente[i]?.[0] === true){
                    <div class="d-flex align-items-center fondo">
                      <div class="spinner-border text-black spinner-border-sm me-1" role="status"></div>
                      <span>Desactivando...</span>
                    </div>
                  }
                </div>
              </td>

              <td class="text-center">
                ${{cliente.situacionExcedido | number: '1.0-0'}}
              </td>

              <!-- Vencido -->
              <td class="text-center">
                  ${{cliente.saldoVencido | number: '1.0-0'}}
              </td>

              <td class="text-center">
                <div style="justify-content: center" class="d-flex align-items-center fondo">
                  @if (solapaReporte === TipoReporte.reporteSaldo && cargandoPendiente[i]?.[1] === false) {
                    ${{cliente.vencidoAutorizado | number: '1.0-0'}}
                    @if (existeSolicitudVencido && cliente.vencidoAutorizado > 0) {
                      <button type="button" [disabled]="bloquear"
                              (click)="anularAutorizado(i, 1, getSolicitudVencido(cliente), accionEliminar.Vencido)"
                              class="fondo" style="border-style: none;" ngbTooltip="Anular autorizado">
                        <i class="fa fa-trash"></i>
                      </button>
                    }
                  } @else if (solapaReporte === TipoReporte.reporteSaldo && cargandoPendiente[i]?.[1] === true){
                    <div class="d-flex align-items-center fondo">
                      <div class="spinner-border text-black spinner-border-sm me-1" role="status"></div>
                      <span>Desactivando...</span>
                    </div>
                  }
                </div>
              </td>

              <td class="text-center">
                ${{cliente.situacionVencido | number: '1.0-0'}}
              </td>

              <!-- Configuración -->
              @if (solapaReporte == TipoReporte.reporteSaldo) {
                <app-reporte-saldo-detalle
                  [cliente]="cliente"
                  [i]="i"
                  [bloquear]="bloquear"
                  [cargandoConfiguracion]="cargandoConfiguracion"
                  [cargandoNotificacion]="cargandoNotificacion"
                  [actualiza]="actualiza"
                  [seleccionado]="seleccionado"
                  [idNotificacionSaldos]="idNotificacionSaldos"
                  (bloquearActualizar)="manejarBloquearActualizar($event)">
                </app-reporte-saldo-detalle>
              } @else if (solapaReporte == TipoReporte.reporteAprobador) {
                <app-reporte-aprobador
                  [cliente]="cliente"
                  [bloquear]="bloquear"
                  [saldosFiltrados]="saldosFiltrados"
                  [checkArray]="checkArray">
                </app-reporte-aprobador>
              }
              @else if (solapaReporte === TipoReporte.reporteSolicitante){
                <app-reporte-solicitante
                  [cliente]="cliente"
                  [cargandoPendiente]="cargandoPendiente"
                  [i]="i"
                  [saldosFiltrados]="saldosFiltrados"
                  (bloquearPendiente)="manejarBloquearPendiente($event)"
                  (saldosFiltradosChange)="saldosFiltrados = $event">
                </app-reporte-solicitante>
              }
              </tbody>
                <tr style="height: 4em;"></tr>
              } @empty {
                <ngb-alert class="alert-warning mt-2">
                  No hay clientes disponibles.
                </ngb-alert>
              }
          </ng-container>

        </table>
      </div>
      <div style="justify-content: center;" *ngIf="this.obteniendoSaldosScroll"
          class="d-flex align-items-center text-primary">
        <div class="spinner-border" role="status"></div><span>Cargando mas datos..</span>
      </div>
    </div>
  </form>
</div>
